import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const ReferralChecklistSection = ({ section, referralId }) => {
    const { referralEvents } = useSelector((state) => state.referrals);

    const sectionData = referralEvents[referralId]?.[section]?.data
        ? JSON.parse(referralEvents[referralId][section].data)
        : undefined;

    return (
        <div style={{ wordWrap: 'normal', overflowX: 'scroll' }}>
            {sectionData && <pre>{JSON.stringify(sectionData, null, 2)}</pre>}
        </div>
    );
};

ReferralChecklistSection.propTypes = {
    section: PropTypes.string.isRequired,
    referralId: PropTypes.string.isRequired,
};
